import type { DietJsonldDietRead } from "@repo/api/catalog/api/schemas/diet-jsonld-diet-read";
import type { DietCatalog, DietCatalogDetail } from "@/features/diets/types";
import { DietDateManager } from "@/lib/helpers/diet-dates";
import type { LocaleType } from "@/types/locale.type";

const useDietDates = ({
  diet,
  saturdays,
  sundays,
  locale,
}: {
  diet: DietCatalogDetail | DietCatalog | DietJsonldDietRead;
  saturdays: boolean;
  sundays: boolean;
  locale: LocaleType;
}) => {
  const manager = new DietDateManager({ diet, locale, saturdays, sundays });

  return {
    nextPossibleDay: (date: Date) => manager.findNextAvailableDate(date),
    nextPossibleDays: (date: Date, count: number) =>
      manager.findNextAvailableDatesArray(date, count),
    // returns "Wtorek", "Środa", etc.
    nextPossibleDayFormatEeee: (date: Date) =>
      manager.formatNextAvailableDateEeee(date),
    areDatesAvailable: (dates: Date[]) => manager.areDatesAvailable(dates),
    lastPossibleOrderDay: manager.lastPossibleOrderDay,
    lastPossibleOrderDayFormatted: manager.lastPossibleOrderDayFormatted,
  };
};

export { useDietDates };
